function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.stinfo{fill-rule:evenodd;clip-rule:evenodd;fill:#6E6E6F !important;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "stinfo",
  d: "M11.3,3.5c0.8,0,1.6,0.6,1.6,1.4c0,0,0,0,0,0c0,0.8-0.6,1.6-1.4,1.6c0,0,0,0,0,0c-0.8,0-1.6-0.6-1.6-1.4 c0,0,0,0,0,0C9.8,4.3,10.5,3.6,11.3,3.5C11.3,3.5,11.3,3.5,11.3,3.5z M9,9.4L7.5,9.5c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0-0.1,0.1-0.1 l3.1-1.8c0.3-0.2,0.8-0.1,1,0.3c0.1,0.2,0.1,0.4,0.1,0.5c-0.6,2-1.1,4-1.5,6c-0.1,0.2,0.1,0.4,0.3,0.5c0,0,0.1,0,0.1,0l1.4-0.1 c0.1,0,0.2,0.1,0.2,0.2c0,0.1,0,0.1-0.1,0.1l-3.1,1.8c-0.3,0.2-0.8,0.1-1-0.3c-0.1-0.2-0.1-0.4-0.1-0.5c0.6-2,1.1-4,1.5-6 c0.1-0.2-0.1-0.4-0.3-0.5C9,9.4,9,9.4,9,9.4z M10.2,0.3c5.5,0,9.9,4.4,9.9,9.9s-4.4,9.9-9.9,9.9s-9.9-4.4-9.9-9.9S4.7,0.3,10.2,0.3z  M10.2,1.4c-4.8,0-8.7,3.9-8.7,8.7c0,4.8,3.9,8.7,8.7,8.7c4.8,0,8.7-3.9,8.7-8.7C18.9,5.3,15,1.4,10.2,1.4L10.2,1.4z"
});

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.3 20.3",
    style: {
      enableBackground: "new 0 0 20.3 20.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.cfc384d3.svg";
export { ForwardRef as ReactComponent };